import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Input, ViewEncapsulation, Component, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

const MAX_SIZE = 64;
const MIN_SIZE = 24;
/**
 * To use this component in a module, you can import the `WindmillLoaderModule`:
 * @example
 * ```typescript
 * import { WindmillLoaderModule } from '@windmill/ng-windmill/loader';
 * ```
 *
 * To use the standalone component directly, you can import `WindmillLoaderComponent`:
 * @example
 * ```typescript
 * import { WindmillLoaderComponent } from '@windmill/ng-windmill/loader';
 * ```
 */
class WindmillLoaderComponent {
    /**
     * The text that is being read on the loading state
     */
    loadingText;
    /**
     * The aria-label attribute
     */
    ariaLabel;
    /**
     * The aria-description attribute
     */
    ariaDescription;
    /**
     * The aria-labelledby attribute
     */
    ariaLabelledby;
    /**
     * The aria-describedby attribute
     */
    ariaDescribedby;
    /**
     * The size of the loader. It is in the [24, 64] range.
     */
    get size() {
        return this._size;
    }
    set size(value) {
        if (value > MAX_SIZE) {
            this._size = MAX_SIZE;
            return;
        }
        if (value < MIN_SIZE) {
            this._size = MIN_SIZE;
            return;
        }
        this._size = value;
    }
    _size = MAX_SIZE;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: WindmillLoaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.10", type: WindmillLoaderComponent, isStandalone: true, selector: "windmill-loader", inputs: { loadingText: "loadingText", ariaLabel: "ariaLabel", ariaDescription: "ariaDescription", ariaLabelledby: "ariaLabelledby", ariaDescribedby: "ariaDescribedby", size: "size" }, ngImport: i0, template: "<div\r\n  class=\"windmill-loader\"\r\n  role=\"alert\"\r\n  style=\"--windmill-loader-size: {{ size }}\">\r\n  <span class=\"cdk-visually-hidden\">{{ loadingText }}</span>\r\n  <div\r\n    class=\"svg-wrapper\"\r\n    role=\"progressbar\"\r\n    tabindex=\"-1\"\r\n    [attr.aria-label]=\"ariaLabel\"\r\n    [attr.aria-labelledby]=\"ariaLabelledby\"\r\n    [attr.aria-description]=\"ariaDescription\"\r\n    [attr.aria-describedby]=\"ariaDescribedby\">\r\n    <svg>\r\n      <circle\r\n        fill=\"none\"\r\n        cx=\"50%\"\r\n        cy=\"50%\"\r\n        r=\"18\"\r\n        [style.stroke-width.px]=\"4\" />\r\n    </svg>\r\n  </div>\r\n</div>\r\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "ngmodule", type: FormsModule }], encapsulation: i0.ViewEncapsulation.None });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: WindmillLoaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'windmill-loader', encapsulation: ViewEncapsulation.None, imports: [CommonModule, FormsModule], standalone: true, template: "<div\r\n  class=\"windmill-loader\"\r\n  role=\"alert\"\r\n  style=\"--windmill-loader-size: {{ size }}\">\r\n  <span class=\"cdk-visually-hidden\">{{ loadingText }}</span>\r\n  <div\r\n    class=\"svg-wrapper\"\r\n    role=\"progressbar\"\r\n    tabindex=\"-1\"\r\n    [attr.aria-label]=\"ariaLabel\"\r\n    [attr.aria-labelledby]=\"ariaLabelledby\"\r\n    [attr.aria-description]=\"ariaDescription\"\r\n    [attr.aria-describedby]=\"ariaDescribedby\">\r\n    <svg>\r\n      <circle\r\n        fill=\"none\"\r\n        cx=\"50%\"\r\n        cy=\"50%\"\r\n        r=\"18\"\r\n        [style.stroke-width.px]=\"4\" />\r\n    </svg>\r\n  </div>\r\n</div>\r\n" }]
        }], propDecorators: { loadingText: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], ariaDescription: [{
                type: Input
            }], ariaLabelledby: [{
                type: Input
            }], ariaDescribedby: [{
                type: Input
            }], size: [{
                type: Input
            }] } });

const moduleComponents = [WindmillLoaderComponent];
class WindmillLoaderModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: WindmillLoaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.10", ngImport: i0, type: WindmillLoaderModule, imports: [CommonModule, FormsModule, WindmillLoaderComponent], exports: [WindmillLoaderComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: WindmillLoaderModule, imports: [CommonModule, FormsModule, moduleComponents] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: WindmillLoaderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule, ...moduleComponents],
                    exports: [...moduleComponents],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { WindmillLoaderComponent, WindmillLoaderModule };
